module.exports = __webpack_public_path__ + "img/exchange-funds-line.f0400029.svg";